var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.cssClass},[_c('icon',{class:_vm.cssClasses,attrs:{"name":_vm.icon,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }